import React, { useEffect } from "react";

import img1 from "../../assets/img/serviceinsidepics/bns2.png";
import img2 from "../../assets/img/serviceinsidepics/bns1.png";
import img3 from "../../assets/img/serviceinsidepics/online1.png";
import Aos from "aos";
import CardSingle from "../Services/Card/CardSingle";
import TextSingle from "../Services/TextCard/TextSingle";
import NormalText from "../Services/NormalText/NormalText";
import LifeSpan from "../Services/lifeSpan-Contact/Lifespan";
import { usePrismicDocumentByUID } from "@prismicio/react";

const PHPFrame = () => {

  const [document] = usePrismicDocumentByUID("services_webportal","phpid");
  const slice5 = document && document?.data;


  useEffect(() => {
    Aos.init();
    window.scrollTo(0, 0);
  }, []);


  const bg = {
    backgroundImage: `url(${slice5?slice5?.body[0].primary.bgimg1.url:"/phpBg1.jfif"})`,
    backgroundSize: "cover",
    backgroundPosition: "right",
  
    backgroundRepeat: " no-repeat",
  };
  const Textbg = {
    backgroundImage: `url(${slice5?slice5?.body[2].primary.bg_img.url:"phpBg2.jpg"})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  
    backgroundRepeat: " no-repeat",
  };
  const NormalTextbg = {
    backgroundSize: "cover",
    backgroundPosition: "cover",
    backgroundImage: `url(${slice5?slice5?.body[3].primary.bgimg3.url:"phpBg3.jfif"})`,
    backgroundRepeat: " no-repeat",
  };
  
  const whiteColor = {
    color: "white",
  };

  return (
    <React.Fragment>
      <div className="webportal main-home mt-130 md-mt-60" style={bg}>
        <div className="partition-bg-wrap">
          <div className="container">
            <div className="row">
              <div className=" col-lg-6 md-pl-14">
                <div className="sec-title3 mb-40">
                  <h2
                    className="title white-color mb-16 Heading"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1800"
                    style={{ fontSize: "40px" }}
                  >
                     {slice5?slice5?.body[0].primary.tittle[0].text:"Php Framework"}
                  </h2>
                  <p
                    className="desc white-color  md-pr-0 sub-text"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="3000"
                    style={{
                      fontSize: "15px",
                      lineHeight: " 1.4",
                      textAlign: "justify",
                    }}
                  >
                    {slice5?slice5?.body[0].primary.text1[0].text: " PHP applications are compatible to all operating systems,                    support all the popular databases, 100% remotely                    configurable, perfect for web programming & provide higher                    performance and speed..                                       PHP (recursive acronym for PHP: Hypertext Preprocessor) is a                    widely-used open source general-purpose scripting language                    that is especially suited for web development and can be                    embedded into HTML."}
                    <br />
                    <br />
                    {slice5?slice5?.body[0].primary.text2[0].text:" It is an open source, server-side, scripting language used                    for the development of web applications. By scripting                    language, we mean a program that is script-based (lines of                    code) written for the automation of tasks.                    A good benefit of using PHP is that it can interact                    with many different database languages including MySQL. ...                    Those are the main reasons we use PHP at Bluelinemedia."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-ss main-home event-bg pt-50 pb-10 md-pt-30 md-pb-0"
        style={{ background: "#4f82c2" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-30"
              data-aos="zoom-out-right"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[0].cardimages.url:img1}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[0].tittle[0].text:"Sencha"}
                subtitle={slice5?slice5?.body[1].items[0].subtittle[0].text:"Deployment of end to end digital testing services framework.Sencha Touch is a user interface JavaScript library, or web framework, specifically built for the Mobile Web. It can be used by Web developers to develop user interfaces for mobile web applications that look and feel like native applications on supported mobile devices."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-30">
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[1].cardimages.url:img2}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[1].tittle[0].text:"Mono Framework"}
                subtitle={slice5?slice5?.body[1].items[1].subtittle[0].text:"Esquare’s managed testing service addresses the key challenges the industry is facing today.Mono is a free and open-source project to create an Ecma standard-compliant .NET Framework-compatible software framework, including a C# compiler and a Common Language Runtime."}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30"
              data-aos="zoom-out-left"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                textClass={whiteColor}
                image={slice5?slice5?.body[1].items[2].cardimages.url:img3}
                title={slice5?slice5?.body[1].items[2].tittle[0].text:"Titanium"}
                subtitle={slice5?slice5?.body[1].items[2].subtittle[0].text:"Our solution focuses on testing of new and upcoming technologies.Titanium SDK is an open-source framework that allows the creation of native mobile apps on platforms including iOS, Android and Windows UWP from a single JavaScript codebase."}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-Text main-home event-bg pt-10 pb-40 md-pt-10 md-pb-20"
        style={Textbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-30"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[0].tittle[0].text:"Enterprise CMS (ECMS)"}
                subtitle={slice5?slice5?.body[2].items[0].subtittle[0].text:"We offer all open source customization, programming and integration.Enterprise content management is the technology used to capture, manage, store, preserve, and deliver content and documents related to organizational processes. ECM tools and strategies allow the management of an organization's unstructured information, wherever that information exists."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-30">
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[1].tittle[0].text:"Web CMS (WCMS)"}
                subtitle={slice5?slice5?.body[2].items[1].subtittle[0].text:"A web content management system (WCMS) is a software content management system (CMS) specifically for web content. It provides website authoring, collaboration, and administration tools that help users with little knowledge of web programming languages or markup languages create and manage website content."}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[2].tittle[0].text:"Electronic document"}
                subtitle={slice5?slice5?.body[2].items[2].subtittle[0].text:"PHP third party tool and plug-in integration such as chat, forum, blog and search engine. Web-based, open source document management system (DMS) written in PHP designed to comply with OIE standard for document management. It features web based access, fine grained control of access to files, and automated install and upgrades."}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="noraml-Text main-home event-bg pt-30 pb-160 md-pt-10 md-pb-470"
        style={NormalTextbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-11 col-md-6 mb-30"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <NormalText
                itemClass="courses-item"
                title={slice5?slice5?.body[3].primary.tittle[0].text:"Our Client Say"}
                listClass="display-none"
                portalList="portal-none"
                cloudList="cloud-none"
                ecommerce="ecommerce-none"
                listtwo="listtwo-none"
                listthree="listthree-none"
                subtitle1={slice5?slice5?.body[3].primary.text1[0].text:"At Esquare, our outstanding PHP Web Development team counts on experienced PHP Web Developers who have effectively completed a number of PHP Web Programming projects like web portals, online shopping / e-commerce website development, CRM, CMS, social networking websites, community websites, and much more."}
                subtitle2={slice5?slice5?.body[3].primary.text2[0].text:"The PHP software works with the web server, which is the software that delivers web pages to the world. ... This process is essentially the same when PHP is installed. You request a file, the web server happens to be running PHP, and it sends HTML back to the browser, thanks to the programming in PHP."}
                subtitle3={slice5?slice5?.body[3].primary.text3[0].text:"Cross-Platform. PHP is, an application can be run on various platforms."}
                subtitle4={slice5?slice5?.body[3].primary.tittle2[0].text:"Ease of use. Any individuals who are new to programming can easily learn to use them within a short duration of time."}
                subtitle5={slice5?slice5?.body[3].primary.text4[0].text:"Basic PHP Syntax. A PHP script can be placed anywhere in the document. The default file extension for PHP files is .php. A PHP file normally contains HTML tags, and some PHP scripting code."}
              />
            </div>
          </div>
        </div>
      </div>
      <LifeSpan />
    </React.Fragment>
  );
};

export default PHPFrame;
